import React, {CSSProperties, ReactNode, useEffect, useRef, useState} from "react";
import {TableCell} from "@material-ui/core";
import classNames from "classnames";
import {TableCellProps} from "@material-ui/core/TableCell";
import CustomizedTooltip from "../Tooltip/Tooltip";

type CustomTableCellProps = TableCellProps & {
    children?: ReactNode;
    className?: string;
    style?: CSSProperties;
    disableHover?:boolean
};

const CustomTableCell: React.FC<CustomTableCellProps> = ({ children, className, style,disableHover = false , ...rest}) => {
    const ref = useRef<HTMLTableCellElement | null>(null);
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.1,
            }
        );

        observer.observe(el);

        return () => {
            if (el) observer.unobserve(el);
        };
    }, []);

    useEffect(() => {
        if (!isVisible) return;

        const el = ref.current;
        if (!el) return;

        const checkEllipsis = () => {
            const hasEllipsis = el.scrollWidth > el.clientWidth;
            setIsEllipsisActive(hasEllipsis);
        };

        const timeout = setTimeout(checkEllipsis, 0);

        return () => clearTimeout(timeout);
    }, [children, style, isVisible]);

    return (
        <CustomizedTooltip disableHoverListener={!isEllipsisActive || disableHover} title={children} copy={false}>
            <TableCell ref={ref} className={classNames(className)} style={style} {...rest}>
                {children}
            </TableCell>
        </CustomizedTooltip>
    );
};

export default CustomTableCell;
